import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Card from "@irati/ui/src/Layout/Card"
import {H5, Label} from "@irati/ui/src/Typography"
import Button, {IconTypes} from "@irati/ui/src/Button"
import Icon from "@irati/ui/src/Icon"
import id from "@irati/utils/id"

interface Props {
  reportId: string,
  title: string,
  body: string,
  onClick: () => void
}

const ReportingCard: FC<Props> = ({reportId, title, body, onClick}) => {
  const idNamespace = id("reward-wallet-reports", reportId)

  return (
    <Card>
      <H5 marginBottom>
        <FormattedMessage id={title} />
      </H5>
      <Label display="inline-block" large marginBottom={3}>
        <FormattedMessage id={body} />
      </Label>
      <Button id={idNamespace} tertiary onClick={onClick}>
        <FormattedMessage id="platform.wallet.tenant.downloadReport.button" />
        <Icon icon={IconTypes.downloadReport} marginLeft />
      </Button>
    </Card>
  )
}

export default ReportingCard
